<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> nodo <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content fxLayout="column">

  <div fxFlex>
    <mat-form-field fxFlex>
      <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre">
    </mat-form-field>
  </div>
  <div fxFlex>
    <mat-form-field fxFlex>
      <textarea placeholder="Descripcion" matInput [(ngModel)]="LOCAL_DATA.descripcion"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex>
    <mat-form-field class="chip-list" fxFlex>
      <mat-chip-list #chipList aria-label="Palabras clave">
        <mat-chip *ngFor="let palabra of LOCAL_DATA.palabrasClave" [selectable]="selectable"
                 [removable]="removable" (removed)="remove(palabra)">
                 {{palabra}}
          <mat-icon matChipRemove >cancel</mat-icon>
        </mat-chip>
        <input placeholder="Nueva palabra clave..."
               [matChipInputFor]="chipList"
               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
               [matChipInputAddOnBlur]="addOnBlur"
               (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
    </mat-form-field>
  </div>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" [disabled]="LOCAL_DATA.nombre==null || LOCAL_DATA.nombre==''">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
